// bootstrap
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
// gsap
import { gsap, smoother } from "../layout";

// scroll to faq section
function faqNavScroll() {
    const faqNavItem = document.querySelector("#faqNavItem");
    const faqSection = document.querySelector("#faq");
    const bsOffcanvas = new Offcanvas('.navbar__offcanvas');
    faqNavItem.addEventListener("click", (ev) => {
        ev.preventDefault();
        gsap.to(window, { duration: 0.4, scrollTo: faqSection });
        bsOffcanvas.hide();
    })
}

// navbar on scroll
function navbarOnScroll() {
    const navbar = document.querySelector('.navbar');

    // get window top
    const doc = document.documentElement;
    let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    
    if (top == 0) {
        navbar.classList.remove('navbar-scroll');
    } else {
        if(!navbar.classList.contains('navbar-scroll')) {
            navbar.classList.add('navbar-scroll');
        }
    }
}

// stores child nav
function storesChildNav() {
    const myModal = new Modal('#storesModal', {
        keyboard: false
    })
    // myModal.show();
}

document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('#home')) {
        faqNavScroll();
    }
    storesChildNav();
});

document.addEventListener('scroll', () => {
    navbarOnScroll();
});